import { apiClient } from "../client";
import type { Envelope } from "./catalog";

/** Saved delivery address. Upstream shape is loosely documented — keep permissive. */
export interface Address {
  id: number;
  name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  mobile?: string | null;
  address?: string | null;
  landmark?: string | null;
  city?: string | null;
  state?: string | null;
  pincode?: string | null;
  country?: string | null;
  /** "home" | "office" | "other" */
  address_type?: string | null;
  is_default?: boolean | number;
  [key: string]: unknown;
}

/** Body for /address-save. Location fields are lookup IDS (stringified), not names. */
export interface SaveAddressPayload {
  first_name: string;
  last_name?: string;
  email?: string;
  phone: string;
  address: string;
  landmark?: string;
  /** City id from /get-city-list. */
  city: string;
  /** State id from /get-state-list. */
  state: string;
  /** Country id ("1" = India). */
  country: string;
  pincode: string;
  /** "home" | "office" | "other" */
  type?: string;
  [key: string]: unknown;
}

export interface UpdateAddressPayload extends Partial<SaveAddressPayload> {
  address_id: number;
}

export interface AddressMutationResponse {
  status: boolean;
  message?: string;
  [key: string]: unknown;
}

export const addresses = {
  /** All saved addresses for the signed-in user. */
  list: () => apiClient.get<Envelope<Address[]> | Address[]>("/address-get"),

  /** Save a new address. */
  save: (payload: SaveAddressPayload) =>
    apiClient.post<AddressMutationResponse>("/address-save", payload),

  /** Update an existing address. */
  update: (payload: UpdateAddressPayload) =>
    apiClient.post<AddressMutationResponse>("/address-update", payload),

  /** Delete an address. */
  remove: (address_id: number) =>
    apiClient.post<AddressMutationResponse>("/address-delete", { address_id }),

  /** Mark an address as the default. */
  setDefault: (address_id: number) =>
    apiClient.post<AddressMutationResponse>("/address-is-default", { address_id }),

  /** Fetch a single address. */
  view: (address_id: number) =>
    apiClient.post<Envelope<Address> | Address>("/address-view", { address_id }),
};
